import { URSSAF } from '@/utils/logos'

// TODO: gérer les traductions
export const serviceEmployeur = {
	url: 'https://www.urssaf.fr/accueil/services/services-employeurs/service-employeur.html',
	title: 'Le service en ligne Employeur',
	description:
		'L’Urssaf met à votre disposition un service en ligne. Il vous permet de gérer votre activité, contacter un conseiller et retrouver tous vos documents.',
	ctaLabel: 'Accéder au service',
	ariaLabel: 'Accéder au service sur urssaf.fr, nouvelle fenêtre',
	logo: URSSAF,
}
